import "../../styles/Topbar.scss";
import { Dropdown } from "react-bootstrap";
import Link from "../common/Link";
import { useEffect, useState } from "react";
import ModalPopup from "../common/Modal";
import { loginClear } from "../../redux/actions/authActions";
import { useDispatch } from "react-redux";
import Person from "../../assets/user.png";
import leftArrow from "../../assets/Icons/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import notificationIcon from "../../assets/Icons/notification-bell .svg";
import { useCountryNavigate } from "../common/UseCountryNavigate";

const Topbar = ({ title, aerrow, currentTab = "", btn, btnName, btnLink }) => {
  const [image, setimage] = useState(Person);
  const [modalLogout, setmodalLogout] = useState(false);
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();

  const FullscreenToggler = () => {
    const elem = document.documentElement;
    if (
      (document.fullScreenElement !== undefined &&
        document.fullScreenElement === null) ||
      (document.msFullscreenElement !== undefined &&
        document.msFullscreenElement === null) ||
      (document.mozFullScreen !== undefined && !document.mozFullScreen) ||
      (document.webkitIsFullScreen !== undefined &&
        !document.webkitIsFullScreen)
    ) {
      if (elem.requestFullScreen) {
        elem.requestFullScreen();
      } else if (elem.mozRequestFullScreen) {
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullScreen) {
        elem.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  };

  const SideBarToggler = () => {
    document.body.classList.toggle("sidebarHide");
  };

  const LogoutCallApi = () => {
    dispatch(loginClear());
    return false;
  };

  useEffect(() => {
    // setimage(data?.user?.profile_pic);
  }, []);

  return (
    <>
      <div className="flex justify-between items-center py-4 px-6 pr-0 pb-0">
        {title === "" ? (
          <img
            src={leftArrow}
            alt="left"
            className="cursor-pointer"
            onClick={() =>
              navigate(-1, { replace: true, state: { currentTab } })
            }
          />
        ) : aerrow === true ? (
          <div className="flex items-center gap-2">
            <img
              src={leftArrow}
              alt="left"
              className="cursor-pointer"
              onClick={() =>
                navigate(-1, { replace: true, state: { currentTab } })
              }
            />
            <span className="label-title">{title}</span>
          </div>
        ) : (
          <span className="label-title">{title}</span>
        )}
        <div className="flex items-center space-x-4">
          {btn && (
            <button
              className={`${btnName === "FAQs"
                  ? "button-small-secondary"
                  : "button-small-primary"
                }`}
              onClick={() => navigate(btnLink)}
            >
              {btnName}
            </button>
          )}
          {/* <input type="text" placeholder="Search" className="input-field" />
          <div className="bg-white text-black px-3 py-3 rounded-[10px]">
            <img src={notificationIcon} alt="noti" className="w-[25px]" />
          </div> */}
        </div>
      </div>
    </>
  );
};

export { Topbar };

// <div className="topbar">
//     <ModalPopup
//       className="alert-box-popup"
//       show={modalLogout}
//       size="sm"
//       onHide={() => setmodalLogout(false)}
//       heading="Are you sure?"
//     >
//       <i className="mdi mdi-information-outline"></i>
//       <div className="actions">
//         <button className="btn btn-primary" onClick={() => LogoutCallApi()}>
//           Logout
//         </button>
//         <button
//           className="btn btn-danger"
//           onClick={() => setmodalLogout(false)}
//         >
//           Cancel
//         </button>
//       </div>
//     </ModalPopup>

//     <div className="d-flex">
//       <div className="sideMenuTop">
//         {/* <img src={Logo} className="logo-large" />
//                     <img src={LogoSmall} className="logo-small" /> */}
//       </div>

//       <div className="sideMenuToggle" onClick={SideBarToggler}>
//         <i className="mdi mdi-menu"></i>
//       </div>

//       {process.env.NODE_ENV !== "production" && (
//         <span className="development">You are in development mode.</span>
//       )}
//     </div>
//     <div className="d-flex">
//       {/* {data.user.role_id?.name !== 'Admin' ?
//         <>
//           <div className="d-flex">
//             <div className='coins'>
//               <div className='coin-list'>
//                 <p>
//                   <img src={require('../../assets/Coin.png')} />
//                   {(data.user.usable_coin_balance)}
//                 </p>
//                 <p>
//                   <img className='award' src={require('../../assets/awards.png')} />
//                   {(data.user.withdrawable_coin_balance)}
//                 </p>
//               </div>
//               {/* <div>
//                 <Link to={'/coins'}>
//                   <button>
//                     <span className="material-icons">add</span>
//                   </button>
//                 </Link>
//               </div>
//             </div>
//           </div>
//         </> : null} */}
//       <i className="mdi mdi-fullscreen" onClick={FullscreenToggler} />
//       <Dropdown className="profile">
//         <Dropdown.Toggle>
//           <img src={image} alt="Profile" />
//         </Dropdown.Toggle>

//         <Dropdown.Menu>
//           <Dropdown.Item as={Link} to="/profile">
//             <i className="mdi mdi-account-circle"></i> Profile
//           </Dropdown.Item>
//           <Dropdown.Item onClick={() => setmodalLogout(true)} href="#">
//             <i className="mdi mdi-power"></i> Logout
//           </Dropdown.Item>
//         </Dropdown.Menu>
//       </Dropdown>
//     </div>
//   </div>
